// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 43 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14 3C19.52 3 24 7.48 24 13C24 18.52 19.52 23 14 23C8.48 23 4 18.52 4 13C4 7.48 8.48 3 14 3Z"
				fill={props.color}
			/>
			<rect
				x="0.75"
				y="0.75"
				width="41.5"
				height="24.5"
				rx="12.25"
				stroke={props.color}
				strokeWidth="1.5"
			/>
		</svg>
	</>
);

export default Icon;
